import '../common/common.js';
import { Utils } from './Utils.js';
import { BasketChange } from './BasketChange.js';
import { SettingsService } from './SettingsService.js';
import { L33t } from './L33t.js';
import { FireBaseBridge } from './FireBaseBridge.js';
import { ButtonHelper } from './ButtonHelper.js';
import { LegacyActionTracking } from './LegacyActionTracking.js';

Utils.initialize();
BasketChange.initialize();
const settingsService = SettingsService.initialize();
L33t.initialize();
FireBaseBridge.initialize(settingsService);
ButtonHelper.initialize();
LegacyActionTracking.initialize();

window.o_global.eventQBus.emitModuleLoaded('ft1.order-core.common-public');
